import {Space} from "antd";
import {ServicePortfolioImagesFormFieldsProps} from "./types";
import {StoreServicePortfolioImagesUpload} from "../../general/portfolio-images";

export function ServicePortfolioImagesFormFields({
  accordionIndex,
  defaultPortfolioImages,
  deletePortfolioImage,
  isDeleteLoading,
  isUploadLoading,
  productServiceId,
  uploadPortfolioImages,
}: ServicePortfolioImagesFormFieldsProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      <StoreServicePortfolioImagesUpload
        defaultPortfolioImages={defaultPortfolioImages}
        deletePortfolioImage={deletePortfolioImage}
        isDeleteLoading={isDeleteLoading}
        isUploadLoading={isUploadLoading}
        productServiceId={productServiceId}
        uploadPortfolioImages={uploadPortfolioImages as any}
      />
    </Space>
  );
}
